import { MutationCallbacks } from '../../../shared/types/mutation';
import useFetch from '../useFetch';
import { FetchKeys } from '../../../shared/constants/queries';
import { getTeamsAndCountries } from '../../../shared/service/data';
import { ConfigDataType, IndustryItem } from '../../../shared/types/filters';
import { IndustryStandardType } from '../../../view/components/IndustryStandards/constants';
import { convertToNestedFormat } from '../../helper/departments';

const parseIndustries = (industries: IndustryItem[]): IndustryItem[] => {
  return industries.map((industry) => {
    // Parse headCountRange from strings to numbers since backend sends as strings and we need numbers for calculations
    if (industry.meta.type === IndustryStandardType.SIZE) {
      const [minHeadCount, maxHeadCount] = industry.meta?.headCountRange || [
        0, 0,
      ];

      const [minHeadCountNumber, maxHeadCountNumber] = [
        Number(minHeadCount),
        Number(maxHeadCount),
      ];

      return {
        ...industry,
        meta: {
          ...industry.meta,
          headCountRange: [minHeadCountNumber, maxHeadCountNumber],
        },
      };
    }

    return industry;
  });
};

export default function useTeamsAndCountries({
  onSuccess,
  onError,
  enable,
}: MutationCallbacks) {
  return useFetch<ConfigDataType>(
    [FetchKeys.teamsAndCountries],
    async () => {
      const {
        countries,
        teams,
        showOrganisationDropdown,
        isTrial,
        contractStartDate,
        industries,
        minimumResponseThreshold,
        totalHeadCount,
        industryId,
        showFeedbackForm,
      } = await getTeamsAndCountries();
      return {
        countries,
        showOrganisationDropdown,
        isTrial,
        teams: convertToNestedFormat(teams),
        contractStartDate,
        industries: parseIndustries(industries),
        minimumResponseThreshold,
        showFeedbackForm,
        totalHeadCount,
        industryId,
      };
    },
    {
      onSuccess,
      onError,
      enabled: false,
    },
  );
}
